import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=1b1578ce&scoped=true&"
import script from "./table-header.vue?vue&type=script&lang=ts&"
export * from "./table-header.vue?vue&type=script&lang=ts&"
import style0 from "./table-header.vue?vue&type=style&index=0&id=1b1578ce&prod&lang=scss&scoped=true&"
import style1 from "./table-header.vue?vue&type=style&index=1&id=1b1578ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1578ce",
  null
  
)

export default component.exports